import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { Nullable, RecordKey } from '@ricoh/ria.client.core/types/core/data.type';

import { isType } from '@ricoh/ria.client.core/utils/data/object';

import type { PatternGlobal } from '~/common/model/api/batch-type/pattern';

/** PatternGlobal Value. */
export const patternGlobalValue = {
  globalVariable: {
    toPath: (name: string): string => `variables['${name}'].value`,
    fromPath: (path: string): string | undefined => {
      const result = /^variables\['(.+?)'\]\.value$/.exec(path);
      if (!result) {
        return undefined;
      }

      return result[1];
    },
  },
  globalBatchType: {
    toPath: (name: string): string => `batch_type['${name}'].name`,
    fromPath: (path: string): string | undefined => {
      const result = /^batch_type\['(.+?)'\]\.name$/.exec(path);
      if (!result) {
        return undefined;
      }

      return result[1];
    },
  },
};

/** Create PatternGlobal. */
export const createPatternGlobal = {
  globalVariable: (variableName: string): PatternGlobal => {
    const path = patternGlobalValue.globalVariable.toPath(variableName);

    return {
      $is: 'global',
      path,
    };
  },

  globalBatchType: (batchType: string): PatternGlobal => {
    const path = patternGlobalValue.globalBatchType.toPath(batchType);

    return {
      $is: 'global',
      path,
    };
  },
};

/** Create PatternGlobal FormField. */
export const createPatternGlobalFormField = {
  globalVariable: <TTabKey extends RecordKey>(tabKey: TTabKey, pattern: PatternGlobal): Nullable<PatternFormFieldItem<TTabKey>> => {
    let patternPath;
    if (isType<PatternGlobal>(pattern, 'global')) {
      patternPath = pattern.path;
    } else {
      return undefined;
    }

    const value = patternGlobalValue.globalVariable.fromPath(patternPath);
    return value
      ? {
          tabKey,
          value,
        }
      : undefined;
  },
  globalBatchType: <TTabKey extends RecordKey>(tabKey: TTabKey, pattern: PatternGlobal): Nullable<PatternFormFieldItem<TTabKey>> => {
    let patternPath;
    if (isType<PatternGlobal>(pattern, 'global')) {
      patternPath = pattern.path;
    } else {
      return undefined;
    }

    const value = patternGlobalValue.globalBatchType.fromPath(patternPath);
    return value
      ? {
          tabKey,
          value: 'batchType',
        }
      : undefined;
  },
};
